import type { ReactElement } from 'react';

type Props = {
  isCreate: boolean;
  name: string;
  onNameChange: (v: string) => void;
  category: string;
  onCategoryChange: (v: string) => void;
  inventoryCategoryId: string;
  onInventoryCategoryIdChange: (v: string) => void;
  condition: string;
  onConditionChange: (v: string) => void;
  upc: string;
  onUpcChange: (v: string) => void;
  mpn: string;
  onMpnChange: (v: string) => void;
  color: string;
  onColorChange: (v: string) => void;
  categoryOptions: Array<{ id: string; label: string }>;
};

export function AboutSection({
  isCreate,
  name,
  onNameChange,
  category,
  onCategoryChange,
  inventoryCategoryId,
  onInventoryCategoryIdChange,
  condition,
  onConditionChange,
  upc,
  onUpcChange,
  mpn,
  onMpnChange,
  color,
  onColorChange,
  categoryOptions,
}: Props): ReactElement {
  return (
    <section id="section-about" className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
      <h2 className="mb-4 text-lg font-semibold text-slate-950">About</h2>
      <div className="grid gap-4 md:grid-cols-2">
        <label className="block md:col-span-2">
          <span className="text-sm font-medium text-slate-700">Name</span>
          <input
            className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2"
            value={name}
            onChange={(e) => onNameChange(e.target.value)}
          />
        </label>
        {isCreate ? (
          <label className="block">
            <span className="text-sm font-medium text-slate-700">Type</span>
            <select
              className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2"
              value={category}
              onChange={(e) => onCategoryChange(e.target.value)}
            >
              <option value="repair_part">Repair part</option>
              <option value="retail_accessory">Retail accessory</option>
              <option value="trade_in">Trade-in</option>
              <option value="refurbished">Refurbished</option>
            </select>
          </label>
        ) : null}
        <label className="block">
          <span className="text-sm font-medium text-slate-700">Category</span>
          <select
            className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2"
            value={inventoryCategoryId}
            onChange={(e) => onInventoryCategoryIdChange(e.target.value)}
          >
            <option value="">None</option>
            {categoryOptions.map((c) => (
              <option key={c.id} value={c.id}>
                {c.label}
              </option>
            ))}
          </select>
        </label>
        <label className="block">
          <span className="text-sm font-medium text-slate-700">Condition</span>
          <select
            className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2"
            value={condition}
            onChange={(e) => onConditionChange(e.target.value)}
          >
            <option value="new">New</option>
            <option value="used">Used</option>
            <option value="refurbished">Refurbished</option>
            <option value="oem">OEM</option>
            <option value="aftermarket">Aftermarket</option>
          </select>
        </label>
        <label className="block">
          <span className="text-sm font-medium text-slate-700">UPC</span>
          <input
            className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2"
            value={upc}
            onChange={(e) => onUpcChange(e.target.value)}
          />
        </label>
        <label className="block">
          <span className="text-sm font-medium text-slate-700">Manufacturer part #</span>
          <input
            className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2"
            value={mpn}
            onChange={(e) => onMpnChange(e.target.value)}
          />
        </label>
        <label className="block">
          <span className="text-sm font-medium text-slate-700">Color</span>
          <input
            className="mt-1 w-full rounded-xl border border-slate-300 px-3 py-2"
            value={color}
            onChange={(e) => onColorChange(e.target.value)}
          />
        </label>
      </div>
    </section>
  );
}
